import { render, staticRenderFns } from "./DemoMode.vue?vue&type=template&id=1992a4ad&scoped=true"
import script from "./DemoMode.vue?vue&type=script&lang=js"
export * from "./DemoMode.vue?vue&type=script&lang=js"
import style0 from "./DemoMode.vue?vue&type=style&index=0&id=1992a4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992a4ad",
  null
  
)

export default component.exports